import React from "react";
import { components } from "react-select";

import styles from "./MenuList.module.scss";

const MenuList = ({ children, ...props }) => {
  // Order based on the color code
  // 1. Set everything in its row
  // 2. Delete empty rows
  // 3. Reorder in between rows
  // const rows = children
  //   .reduce((prev, child) => {
  //     const value = child.props.value;
  //     const rowIndex = value === "inherited" ? 6 : Math.floor(value / 100);
  //
  //     prev[rowIndex] = prev[rowIndex] ? [...prev[rowIndex], child] : [child];
  //
  //     return prev;
  //   }, [])
  //   .filter((row) => Array.isArray(row))
  //   .map((row) =>
  //     row.sort((a, b) =>
  //       a.props.value === "inherited" ? 1 : a.props.value - b.props.value
  //     )
  //   );

  // Order defined in specs
  const rows = [];
  const itemsByRow = 7;
  const availableColors = children.filter((c) => !c?.props?.data?.isDeprecated);
  for (let i = 0; i < availableColors.length; i += itemsByRow) {
    rows.push(availableColors.slice(i, i + itemsByRow));
  }

  return (
    <components.MenuList {...props}>
      {rows.map((row, index) => (
        <div className={styles.row} key={index}>
          {row}
        </div>
      ))}
    </components.MenuList>
  );
};

export default MenuList;
